import { cn } from "@/lib/cn";
import type { HTMLAttributes } from "react";

interface EmptyStateProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  description?: string;
}

export function EmptyState({ title, description, className, ...props }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-2 rounded-[var(--radius-lg)] border border-dashed border-[var(--color-border)] bg-[var(--color-surface-muted)] px-6 py-16 text-center",
        className,
      )}
      {...props}
    >
      <p className="text-sm font-medium text-[var(--color-text)]">{title}</p>
      {description ? (
        <p className="max-w-md text-sm text-[var(--color-text-muted)]">{description}</p>
      ) : null}
    </div>
  );
}
